import { useLocation } from 'react-router-dom'
import {
  TooltipProvider,
} from '@/components/ui/tooltip'
import { useTranslation } from 'react-i18next'
import { NAV_ITEMS } from '@/components/nav-config'

// FS-579: Data-area subpages that render inside the shared PageLayout shell
// would otherwise inherit the section-level "Data" label from NAV_ITEMS.
// Subpages with their own identity override the label here (mirrors the
// DataSidebar item definitions).
const SUBPAGE_OVERRIDES = [
  { prefix: '/connectors', labelKey: 'nav:menu.connectors' },
] as const

export default function AppTopbar() {
  const location = useLocation()
  const { t } = useTranslation()

  const override = SUBPAGE_OVERRIDES.find(
    (o) => location.pathname === o.prefix || location.pathname.startsWith(`${o.prefix}/`),
  )
  const activePage = NAV_ITEMS.find((p) =>
    location.pathname.startsWith(p.path) ||
    (p.childPaths?.some(cp => location.pathname.startsWith(cp)) ?? false)
  )
  const label = override ? t(override.labelKey) : activePage ? t(activePage.topbarLabelKey) : ''

  return (
    <TooltipProvider delayDuration={300}>
      <header className="flex h-[60px] shrink-0 items-center justify-between border-b border-[#e5e5e5] bg-white px-6 py-5 dark:border-dark-border dark:bg-dark-card">
        {/* UI-67: the title alone. The section glyph that sat beside it
            labelled nothing the word did not already say, and Settings and
            Tag Mapping never carried one — so it read as an inconsistency
            rather than as information. The icons stay in the left rail,
            where they are the only label a collapsed item has. */}
        <div className="flex items-center">
          <span className="text-sm font-medium text-[#171717] dark:text-gray-100 truncate">
            {label}
          </span>
        </div>
      </header>
    </TooltipProvider>
  )
}
